// AUTH-CADASTRO Ato 1 (docs/pacotes/AUTH-CADASTRO.md, decisão 3): trava da sessão de recuperação de senha.
// No PKCE a biblioteca nunca emite PASSWORD_RECOVERY; a única marca é o verificador gravado com o sufixo
// "/PASSWORD_RECOVERY" (auth-js helpers getCodeChallengeAndMethod), apagado na troca do código. Por isso a marca é
// lida aqui, antes de o cliente do Supabase ser criado, e vira uma marca própria no localStorage.

const RECOVERY_LOCK_KEY = 'gonx-recovery-lock';
const CODE_VERIFIER_KEY = 'sb-ebhjbrnlrshsjrctwejs-auth-token-code-verifier';

const safeGet = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

/** Chamado em client.ts antes do createClient: código na URL + verificador de recuperação = sessão de recuperação. */
export const captureRecoveryCallback = (): void => {
  if (typeof window === 'undefined') return;
  const hasCode = new URLSearchParams(window.location.search).has('code');
  if (!hasCode) return;
  const verifier = safeGet(CODE_VERIFIER_KEY);
  if (verifier && verifier.includes('/PASSWORD_RECOVERY')) {
    try {
      localStorage.setItem(RECOVERY_LOCK_KEY, '1');
    } catch {
      /* sem armazenamento: a trava não liga */
    }
  }
};

export const isRecoveryLocked = (): boolean => safeGet(RECOVERY_LOCK_KEY) === '1';

export const clearRecoveryLock = (): void => {
  try {
    localStorage.removeItem(RECOVERY_LOCK_KEY);
  } catch {
    /* ignorar */
  }
};

/** Erro de link do Supabase na consulta ou no fragmento da URL (otp_expired, access_denied...). */
export const getLinkError = (): string | null => {
  if (typeof window === 'undefined') return null;
  const query = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.substring(1));
  return query.get('error_code') || hash.get('error_code') || query.get('error') || hash.get('error');
};

/** Código ainda na URL depois da inicialização = não foi trocado (outro navegador, link já usado ou troca que falhou). */
export const hasUnexchangedCode = (): boolean =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('code');

// Rotas que ficam fora da trava: a própria tela de nova senha e as públicas por link ou institucionais.
const UNLOCKED_PATHS = [
  '/reset-password',
  '/apresentacao',
  '/confirm-loan-read',
  '/obrigado',
  '/thank-you',
  '/payment-callback',
];
const UNLOCKED_PREFIXES = ['/signature/', '/cotacao/responder/', '/track/', '/accept-invitation/'];

export const isPathOutsideRecoveryLock = (pathname: string): boolean =>
  UNLOCKED_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ||
  UNLOCKED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
